export default {
  "mainVegetable": "vegetables",
  "mainVegetable/01": "vegetables/aubergines",
  "mainVegetable/02": "vegetables/asparagus",
  "mainVegetable/03": "vegetables/avocado",
  "mainVegetable/04": "vegetables/beets",
  "mainVegetable/05": "vegetables/broccoli",
  "mainVegetable/06": "vegetables/carrots",
  "mainVegetable/07": "vegetables/celery",
  "mainVegetable/08": "vegetables/mushrooms",
  "mainVegetable/09": "vegetables/cabbage",
  "mainVegetable/10": "vegetables/brussels-sprouts",
  "mainVegetable/11": "vegetables/chinese-cabbage",
  "mainVegetable/12": "vegetables/cauliflower",
  "mainVegetable/13": "vegetables/coleslaw",
  "mainVegetable/14": "vegetables/cucumber",
  "mainVegetable/15": "vegetables/zucchini",
  "mainVegetable/16": "vegetables/endives",
  "mainVegetable/17": "vegetables/spinach",
  "mainVegetable/18": "vegetables/fava-beans",
  "mainVegetable/19": "vegetables/flageolets",
  "mainVegetable/20": "vegetables/flat-beans",
  "mainVegetable/21": "vegetables/dry-beans",
  "mainVegetable/22": "vegetables/green-beans",
  "mainVegetable/23": "vegetables/lenses",
  "mainVegetable/24": "vegetables/macedoine",
  "mainVegetable/25": "vegetables/mais",
  "mainVegetable/26": "vegetables/mesclun",
  "mainVegetable/27": "vegetables/turnips",
  "mainVegetable/28": "vegetables/onions",
  "mainVegetable/29": "vegetables/peas-soya",
  "mainVegetable/30": "vegetables/peppers",
  "mainVegetable/31": "vegetables/potatoes-and-potatoes",
  "mainVegetable/32": "vegetables/soybean-sprouts",
  "mainVegetable/33": "vegetables/radishes",
  "mainVegetable/34": "vegetables/oak-leaf-salad",
  "mainVegetable/35": "vegetables/frisee-salad",
  "mainVegetable/36": "vegetables/salade-iceberg",
  "mainVegetable/37": "vegetables/piedmontese-salad",
  "mainVegetable/38": "vegetables/rice-salads",
  "mainVegetable/39": "vegetables/roman-salad",
  "mainVegetable/40": "vegetables/young-shoots",
  "mainVegetable/41": "vegetables/lettuce",
  "mainVegetable/42": "vegetables/lambs-lettuce",
  "mainVegetable/43": "vegetables/arugula",
  "mainVegetable/44": "vegetables/salsifies",
  "mainVegetable/45": "vegetables/taboule",
  "mainVegetable/46": "vegetables/tomatoes",
  "mainVegetable/47": "vegetables/buttered-bean",
  "mainVegetable/48": "vegetables/chickpea",
  "mainVegetable/49": "vegetables/leeks",
  "mainVegetable/50": "vegetables/pumpkin",
  "mainVegetable/51": "vegetables/kidney-bean",
  "mainVegetable/52": "vegetables/apples",
  "mainVegetable/53": "vegetables/chestnuts",
  "mainVegetable/54": "vegetables/prunes",
  "mainVegetable/55": "vegetables/gardener",
  "mainVegetable/56": "vegetables/black-olives",
  "mainVegetable/57": "vegetables/artichokes",
  "mainVegetable/58": "vegetables/red-peppers",
  "mainVegetable/59": "vegetables/flat-green-beans",
  "mainVegetable/60": "vegetables/spring",
  "mainVegetable/61": "vegetables/ratatouille",
  "mainVegetable/62": "vegetables/couscous",
  "mainVegetable/63": "vegetables/tagine",
  "mainVegetable/64": "vegetables/curry-vegetables",
  "mainVegetable/65": "vegetables/pea-cups",
  "mainVegetable/66": "vegetables",
  "mainVegetable/67": "vegetables/coral-lenses",
  "mainVegetable/68": "vegetables/quinoa",
  "mainVegetable/69": "vegetables/spelt",
  "mainVegetable/70": "vegetables/bulgur",
  "mainVegetable/71": "vegetables/red-cabbage",
  "mainVegetable/72": "vegetables/kale",
  "mainVegetable/73": "vegetables/chervil",
  "mainVegetable/74": "vegetables/grains-and-seeds",
  "mainVegetable/75": "vegetables/legumes",
  "mainVegetable/76": "vegetables/sweet-potato",
  "mainVegetable/77": "vegetables/pumpkins",
  "mainVegetable/78": "vegetables/dough",
  "mainVegetable/79": "vegetables/beans",
  "mainVegetable/80": "vegetables/pea-carrots",
  "mainVegetable/81": "vegetables/peas",
  "mainVegetable/82": "vegetables/edamame",
  "mainVegetable/83": "vegetables/barley",
  "mainVegetable/84": "vegetables/salad-mix",
  "mainVegetable/85": "vegetables/sugar-loaf-chicory",
  "mainVegetable/86": "vegetables/lamb-lettuce",
  "mainVegetable/87": "vegetables/baby-spinach",
  "mainVegetable/88": "vegetables/baby-green-batavia",
  "mainVegetable/89": "vegetables/swiss-chard",
  "mainVegetable/90": "vegetables/parsnip",
  "mainVegetable/91": "vegetables/black-venus-rice",
  "mainVegetable/92": "vegetables/bean-mix",
  "mainVegetable/93": "vegetables/black-beans",
  "mainVegetable/94": "vegetables/pointed-cabbage",
  "mainVegetable/95": "vegetables/white-beans",
  "mainVegetable/96": "vegetables/dried-tomatoes",
  "mainVegetable/97": "vegetables/mix-of-vegetables",
  "mainVegetable/98": "vegetables/butternut",
  "productRange": "ranges",
  "productRange/4G_BIO": "ranges/4g-bio",
  "productRange/4G_SRP": "ranges/4g-srp",
  "productRange/CAN_A_POEL": "ranges/pan-fried-canned-vegetables",
  "productRange/CAN_SEC_BI": "ranges/dried-vegetables-cooked-in-very-little-organic-juice-canned",
  "productRange/CAN_SEC_CO": "ranges/canned-cooked-dried-vegetables",
  "productRange/CAN_SEC_CU": "ranges/dried-vegetables-cooked-in-very-little-juice",
  "productRange/CAN_SEC_NA": "ranges/dried-vegetables-nature-canned",
  "productRange/CAN_VAPEUR": "ranges/canned-steamed-vegetables",
  "productRange/CAN_VEG_SA": "ranges/canned-saa-plain-vegetables",
  "productRange/CAN_VEG_SR": "ranges/canned-plain-srp-vegetables",
  "productRange/CLASSICVEG": "ranges/classic-vegetables",
  "productRange/COLDVEGE": "ranges/cold-vegetables",
  "productRange/COOKMUSH": "ranges/cooked-mushrooms",
  "productRange/CRUDITES": "ranges/crudités",
  "productRange/DE_NOS_PRO": "ranges/from-our-producers",
  "productRange/DOYMUSHACC": "ranges/cooked-mushrooms-accompaniment",
  "productRange/DOYMUSHAPE": "ranges/cooked-mushrooms-aperitif",
  "productRange/DRYVEGE": "ranges/dry-vegetables",
  "productRange/FROZENVEGE": "ranges/frozen-vegetables-to-share",
  "productRange/FRZ_ASTUCE": "ranges/my-vegetable-tips",
  "productRange/FRZ_GRATIN": "ranges/gratins",
  "productRange/FRZ_KELLO": "ranges/frozen-pulses-and-cereals",
  "productRange/FRZ_LEG_CO": "ranges/frozen-conventional-vegetables",
  "productRange/FRZ_PUREES": "ranges/frozen-purees",
  "productRange/FRZ_VEG_BI": "ranges/frozen-organic",
  "productRange/FRZ_VEG_SR": "ranges/frozen-srp",
  "productRange/INDFROZVEG": "ranges/individual-frozen-vegetables",
  "productRange/JEUNES_POU": "ranges/young-plants",
  "productRange/LAITUES": "ranges/lettuce",
  "productRange/LOOP": "ranges/loop",
  "productRange/LUNCH_BOWL": "ranges/lunch-bowl",
  "productRange/MACHE_BASE": "ranges/lamb's-lettuce-and-lamb's-lettuce-base",
  "productRange/MEL_LAITUE": "ranges/lettuce-mix",
  "productRange/MUSHNATEMI": "ranges/natural-mushrooms,-sliced-and-canned",
  "productRange/MUSHNATENT": "ranges/natural-mushrooms,-whole,-canned",
  "productRange/MUSHNATEPA": "ranges/natural-mushrooms,-thickly-sliced",
  "productRange/MUSHNATMIN": "ranges/natural-mushrooms-mini-canned",
  "productRange/MUSHROOMS": "ranges/mushrooms",
  "productRange/SUNVEGE": "ranges/vegetables-of-the-sun",
  "productRange/TRAIT_CRUD": "ranges/crudités-caterer",
  "productRange/TRAIT_TABO": "ranges/catering-tabbouleh",
  "productRange/TUS_RECETA": "ranges/your-recipes",
  "productRange/WORLDVEGE": "ranges/world-vegetables",
  "productRange/PREPARED_VEG": "ranges/prepared-vegetables",
  "productRange/BEAN_SAUCE": "ranges/beans-in-sauce",
  "productRange/BEANS": "ranges/beans",
  "productRange/BIO": "ranges/bio",
  "productRange/BOND_KIDS": "ranges/bonduelle-kids",
  "productRange/CAN_BIO": "ranges",
  "productRange/CAN_SEC_PR": "ranges",
  "productRange/CARTA_DELL": "ranges/carta-delle-insalate",
  "productRange/CAN_PETITS": "ranges",
  "productRange/CAN_BOCAL": "ranges",
  "productRange/CEREAL_CAN": "ranges/cereals-ambient",
  "productRange/CEREAL_FRZ": "ranges/cereals-frozen",
  "productRange/CEREALI": "ranges/cereals",
  "productRange/CEREALLEGR": "ranges/cereallegre",
  "productRange/COCCOLE": "ranges/coccole",
  "productRange/CORN": "ranges/corn",
  "productRange/CREATIF": "ranges/creatif",
  "productRange/FRANCAIS": "ranges/100-french",
  "productRange/FRZ_FRY_MI": "ranges",
  "productRange/FRZ_MELANG": "ranges",
  "productRange/FRZ_POELEE": "ranges/Frozen prepared mixes",
  "productRange/INSALATE_D": "ranges/insalate-degli-agricoltori",
  "productRange/INSALATONA": "ranges/insalatona-piu",
  "productRange/LE_REGIONA": "ranges/le-regionali",
  "productRange/LEGUMIO": "ranges/legumio",
  "productRange/MIXES_CORN": "ranges/mixes-with-corn",
  "productRange/MONO_VEGE": "ranges/mono-vegetables",
  "productRange/MUSHROOMS  ": "ranges/mushroom",
  "productRange/NATURA_IN": "ranges/natura-in-padella",
  "productRange/OTHER_VEG": "ranges/other-vegetables",
  "productRange/PEAS": "ranges/peas",
  "productRange/READY_FROZ": "ranges/ready-frozen-meals",
  "productRange/SOUPS": "ranges/veggie-for-soups",
  "productRange/SPINACH": "ranges/spinach",
  "productRange/STEAM_CAN": "ranges/steam-can",
  "productRange/STEAM_FRZ": "ranges/steam-frozen",
  "productRange/STEAM_MIX": "ranges/steam-frozen-mixes",
  "productRange/STUZZICHIA": "ranges/stuzzichiamo",
  "productRange/TOUCHE": "ranges/enricher",
  "productRange/TRAIT_SAL": "ranges",
  "productRange/TUS_RECETA ": "ranges/your-recipes",
  "productRange/VEG_TO_FRY": "ranges/vegetables-to-fry",
  "productRange/VEGGIE": "ranges/veggie-rice",
  "productRange/FRZ_JUSTEA": "ranges/vegetable-puck",
  "productRange/SALABIS": "ranges/bonduelle-s-commitment",
  "productRange/BON_SENGAG": "ranges/salad",
  "productRange/CROUSTIS": "ranges/croustis",
  "season": "seasons",
  "season/1": "seasons/summer",
  "season/2": "seasons/autumn",
  "season/3": "seasons/wintertime",
  "season/4": "seasons/springtime",
  "season/5": "seasons/christmas",
  "technologie": "technology",
  "technologie/AC01": "technology/preserve",
  "technologie/AD01": "technology/frozen",
  "technologie/AG01": "technology/fresh",
  "technologie/AT01": "technology/caterer",
  "recipeDish": "type-of-plat",
  "recipeDish/ACC": "type-of-plat/accompaniment",
  "recipeDish/APE": "type-of-plat/aperitif",
  "recipeDish/DES": "type-of-plat/dessert",
  "recipeDish/ENT": "type-of-plat/entrance",
  "recipeDish/PLAT": "type-of-plat/dish",
  "recipeDish/SAL": "type-of-plat/salad",
  "recipeDish/SNA": "type-of-plat/snack-bar",
  "recipeDish/PDE": "type-of-plat/breakfast",
  "recipeDish/DEJ": "type-of-plat/lunch",
  "recipeDish/TRA": "type-of-plat/traditional",
  "recipeDish/GOU": "type-of-plat/gourmet-food",
  "recipeDish/ETH": "type-of-plat/ethnicity",
  "recipeDish/FCH": "type-of-plat/for-children",
  "recipeDish/SOU": "type-of-plat/soup",
  "pred-recipeTimingCook-facet": "baking",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "baking/0-15-minutes",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "baking/15-30-minutes",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "baking/30-45-minutes",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "baking/45-minutes",
  "pred-recipeTimingPreparation-facet": "preparation",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "preparation/0-15-minutes",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "preparation/15-30-minutes",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "preparation/30-45-minutes",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "preparation/45-minutes",
  "pred-recipeCost-Facet": "budget",
  "pred-recipeCost-Facet/petit": "budget/cheap",
  "pred-recipeCost-Facet/moyen": "budget/medium",
  "pred-recipeCost-Facet/grand": "budget/high",
  "recipeDifficulty": "preparation",
  "recipeDifficulty/1": "preparation/easy",
  "recipeDifficulty/2": "preparation/medium",
  "recipeDifficulty/3": "preparation/elaborate",
  "recipeDishNumber": "guests",
  "recipeDishNumber/1": "guests/1",
  "recipeDishNumber/2": "guests/2",
  "recipeDishNumber/3": "guests/3",
  "recipeDishNumber/4": "guests/4",
  "recipeDishNumber/5": "guests/5",
  "recipeDishNumber/6": "guests/6",
  "recipeDishNumber/7": "guests/7",
  "recipeDishNumber/8": "guests/8",
  "productTheme": "products-by-theme",
  "productTheme/ACC": "products-by-theme/accompaniment",
  "productTheme/BEA": "products-by-theme/beans",
  "productTheme/BIS": "products-by-theme/beans-in-sauce",
  "productTheme/BIO": "products-by-theme/bio",
  "productTheme/CAN": "products-by-theme/canned-food",
  "productTheme/CER": "products-by-theme/cereals",
  "productTheme/CLS": "products-by-theme/classics",
  "productTheme/DLE": "products-by-theme/vegetables",
  "productTheme/EDR": "products-by-theme/meal-enrichers",
  "productTheme/ENT": "products-by-theme/entrees",
  "productTheme/FRZ": "products-by-theme/surgele",
  "productTheme/FSD": "products-by-theme/pour-les-salades",
  "productTheme/FSH": "products-by-theme/fees",
  "productTheme/ING": "products-by-theme/ingredients-for-my-recipes",
  "productTheme/JAR": "products-by-theme/vegetables-in-jar",
  "productTheme/LBW": "products-by-theme/lunch-bowl",
  "productTheme/LDF": "products-by-theme/vegetables-in-the-oven",
  "productTheme/LEG": "products-by-theme/les-legumineuses",
  "productTheme/LGO": "products-by-theme/legumio",
  "productTheme/LGR": "products-by-theme/grilled-vegetables",
  "productTheme/LGS": "products-by-theme/vegetables-for-soup",
  "productTheme/MAI": "products-by-theme/the-but",
  "productTheme/MUS": "products-by-theme/mushrooms",
  "productTheme/NEW": "products-by-theme/new-products",
  "productTheme/PDH": "products-by-theme/dry-vegetable-kitchen-dishes",
  "productTheme/PDL": "products-by-theme/basket-of-vegetables",
  "productTheme/PHR": "products-by-theme/pasta-and-pasta",
  "productTheme/PLP": "products-by-theme/plat-principal",
  "productTheme/RAL": "products-by-theme/rice-vegetable",
  "productTheme/RDM": "products-by-theme/kitchen-plates",
  "productTheme/SAL": "products-by-theme/all-for-my-salaries",
  "productTheme/SDB": "products-by-theme/salad-bowls",
  "productTheme/SNK": "products-by-theme/snacking",
  "productTheme/SUP": "products-by-theme/soup",
  "productTheme/TEX": "products-by-theme/tex-mex",
  "productTheme/VGP": "products-by-theme/vegetable-proteins",
  "recipeTheme": "recipes-by-theme",
  "recipeTheme/01": "recipes-by-theme/festive-recipes",
  "recipeTheme/02": "recipes-by-theme/aperitif",
  "recipeTheme/03": "recipes-by-theme/salads-and-snacks",
  "recipeTheme/04": "recipes-by-theme/soups-and-gaspachos",
  "recipeTheme/05": "recipes-by-theme/quiche-cake-and-gratins",
  "recipeTheme/06": "recipes-by-theme/special-children",
  "recipeTheme/07": "recipes-by-theme/desserts",
  "recipeTheme/08": "recipes-by-theme/vegetarians",
  "recipeTheme/09": "recipes-by-theme/accompaniments",
  "recipeTheme/10": "recipes-by-theme/come-from-away",
  "recipeTheme/11": "recipes-by-theme/mijotes",
  "recipeTheme/12": "recipes-by-theme/salads-and-barbecues",
  "recipeTheme/13": "recipes-by-theme/snacks-and-fingerfood",
  "recipeTheme/14": "recipes-by-theme/plat-principal",
  "recipeTheme/15": "recipes-by-theme/desserts-and-pastries",
  "recipeTheme/16": "recipes-by-theme/entrees-et-soupes",
  "recipeTheme/17": "recipes-by-theme/salads",
  "recipeTheme/18": "recipes-by-theme/bowls",
  "recipeTheme/19": "recipes-by-theme/soups",
  "recipeTheme/20": "recipes-by-theme/snacks",
  "recipeTheme/21": "recipes-by-theme/sauce",
  "recipeTheme/22": "recipes-by-theme/single-dishes",
  "recipeTheme/23": "recipes-by-theme/other-dishes",
  "recipeTheme/24": "recipes-by-theme/plats-au-four",
  "recipeTheme/25": "recipes-by-theme/mexican",
  "recipeTheme/26": "recipes-by-theme/around-the-world",
  "recipeTheme/27": "recipes-by-theme/a-day-without-meat",
  "recipeTheme/28": "recipes-by-theme/low-carb",
  "recipeTheme/33": "recipes-by-theme/base-of-lenses",
  "recipeTheme/34": "recipes-by-theme/cauliflower-base",
  "recipeTheme/35": "recipes-by-theme/potato-base",
  "recipeTheme/36": "recipes-by-theme/carrot-base",
  "recipeTheme/37": "recipes-by-theme/spinach-base",
  "recipeTheme/38": "recipes-by-theme/base-of-peppers",
  "recipeTheme/39": "recipes-by-theme/mushroom-base",
  "recipeTheme/40": "recipes-by-theme/base-of-flat-green-beans",
  "recipeTheme/41": "recipes-by-theme/corn-base",
  "recipeTheme/42": "recipes-by-theme/base-peas",
  "recipeTheme/43": "recipes-by-theme/base-red-beans",
  "recipeTheme/44": "recipes-by-theme/flageolet-base",
  "recipeTheme/45": "recipes-by-theme/chickpea-base",
  "recipeTheme/46": "recipes-by-theme/broccoli-base",
  "pred-particularite": "food-habits",
  "pred-particularite/Sans%20conservateur": "food-habits/no-preservatives",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "food-habits",
  "pred-particularite/Sans%20colorant": "food-habits/dye-free",
  "pred-particularite/Sans%20sucre%20ajout%E9": "food-habits/no-added-sugars",
  "pred-particularite/Sans%20sel%20ajout%E9": "food-habits/no-salt-added",
  "pred-particularite/Sans%20additif": "food-habits/without-additive",
  "pred-particularite/": "food-habits/naturally-occurring-salt",
  "pred-particularite/Sans%20lactose": "food-habits/lactose-free",
  "pred-particularite/Sans%20gluten": "food-habits/gluten-free",
  "pred-particularite/V%E9g%E9tarien": "food-habits/veggie",
  "pred-particularite/V%E9g%E9talien": "food-habits/vegan",
  "pred-particularite/Sans%20sulfite": "food-habits/sulfite-free",
  "pred-particularite/A%20la%20vapeur": "food-habits/steam",
  "pred-particularite/Sans%20condiment": "food-habits/without-condiment",
  "cultureType": "culture-type",
  "cultureType/Bio": "culture-type/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "culture-type/no-pesticide-residue",
  "cultureType/Sans%20OGM": "culture-type/gmo-free",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "food-habits/vegan",
  "pred-particularite/recipeVeggie": "food-habits/veggie",
  "pred-particularite/recipeGlutenfree": "food-habits/gluten-free",
  "pred-particularite/recipeLactosefree": "food-habits/lactose-free",
  "cultureOrigin": "origin-of-culture",
  "cultureOrigin/31": "origin-of-culture/azerbaijan",
  "cultureOrigin/32": "origin-of-culture/argentina",
  "cultureOrigin/36": "origin-of-culture/australia",
  "cultureOrigin/40": "origin-of-culture/austria",
  "cultureOrigin/51": "origin-of-culture/armenia",
  "cultureOrigin/56": "origin-of-culture/belgium",
  "cultureOrigin/68": "origin-of-culture/bolivia",
  "cultureOrigin/70": "origin-of-culture/bosnia-and-herzegovina",
  "cultureOrigin/76": "origin-of-culture/brazil",
  "cultureOrigin/97": "origin-of-culture/european-union",
  "cultureOrigin/100": "origin-of-culture/bulgaria",
  "cultureOrigin/104": "origin-of-culture/burma",
  "cultureOrigin/120": "origin-of-culture/cameroon",
  "cultureOrigin/124": "origin-of-culture/canada",
  "cultureOrigin/152": "origin-of-culture/chile",
  "cultureOrigin/156": "origin-of-culture/china",
  "cultureOrigin/188": "origin-of-culture/costa-rica",
  "cultureOrigin/191": "origin-of-culture/croatia",
  "cultureOrigin/196": "origin-of-culture/cyprus",
  "cultureOrigin/203": "origin-of-culture/czech-republic",
  "cultureOrigin/208": "origin-of-culture/denmark",
  "cultureOrigin/231": "origin-of-culture/ethiopia",
  "cultureOrigin/233": "origin-of-culture/estonia",
  "cultureOrigin/246": "origin-of-culture/finland",
  "cultureOrigin/250": "origin-of-culture/france",
  "cultureOrigin/258": "origin-of-culture/french-polynesia",
  "cultureOrigin/276": "origin-of-culture/germany",
  "cultureOrigin/300": "origin-of-culture/greece",
  "cultureOrigin/320": "origin-of-culture/guatemala",
  "cultureOrigin/344": "origin-of-culture/hong-kong",
  "cultureOrigin/348": "origin-of-culture/hungary",
  "cultureOrigin/352": "origin-of-culture/iceland",
  "cultureOrigin/356": "origin-of-culture/indies",
  "cultureOrigin/360": "origin-of-culture/indonesia",
  "cultureOrigin/372": "origin-of-culture/ireland",
  "cultureOrigin/376": "origin-of-culture/israel",
  "cultureOrigin/380": "origin-of-culture/italy",
  "cultureOrigin/398": "origin-of-culture/kazakhstan",
  "cultureOrigin/404": "origin-of-culture/kenya",
  "cultureOrigin/414": "origin-of-culture/kuwait",
  "cultureOrigin/417": "origin-of-culture/kyrgyzstan",
  "cultureOrigin/422": "origin-of-culture/lebanon",
  "cultureOrigin/428": "origin-of-culture/latvia",
  "cultureOrigin/440": "origin-of-culture/lithuania",
  "cultureOrigin/442": "origin-of-culture/luxembourg",
  "cultureOrigin/450": "origin-of-culture/madagascar",
  "cultureOrigin/470": "origin-of-culture/malta",
  "cultureOrigin/480": "origin-of-culture/mauritius",
  "cultureOrigin/484": "origin-of-culture/mexico",
  "cultureOrigin/498": "origin-of-culture/moldova",
  "cultureOrigin/499": "origin-of-culture/montenegro",
  "cultureOrigin/504": "origin-of-culture/morocco",
  "cultureOrigin/528": "origin-of-culture/the-netherlands",
  "cultureOrigin/548": "origin-of-culture/vanuatu",
  "cultureOrigin/578": "origin-of-culture/norway",
  "cultureOrigin/586": "origin-of-culture/pakistan",
  "cultureOrigin/604": "origin-of-culture/peru",
  "cultureOrigin/616": "origin-of-culture/poland",
  "cultureOrigin/620": "origin-of-culture/portugal",
  "cultureOrigin/634": "origin-of-culture/qatar",
  "cultureOrigin/642": "origin-of-culture/romania",
  "cultureOrigin/643": "origin-of-culture/russia",
  "cultureOrigin/703": "origin-of-culture/slovakia",
  "cultureOrigin/704": "origin-of-culture/vietnam",
  "cultureOrigin/705": "origin-of-culture/slovenia",
  "cultureOrigin/724": "origin-of-culture/spain",
  "cultureOrigin/752": "origin-of-culture/sweden",
  "cultureOrigin/756": "origin-of-culture/switzerland",
  "cultureOrigin/764": "origin-of-culture/thailand",
  "cultureOrigin/784": "origin-of-culture/united-arab-emirates",
  "cultureOrigin/792": "origin-of-culture/turkey",
  "cultureOrigin/795": "origin-of-culture/turkmenistan",
  "cultureOrigin/804": "origin-of-culture/ukraine",
  "cultureOrigin/818": "origin-of-culture/egypt",
  "cultureOrigin/826": "origin-of-culture/united-kingdom",
  "cultureOrigin/834": "origin-of-culture/tanzania",
  "cultureOrigin/840": "origin-of-culture/united-states",
  "cultureOrigin/999": "origin-of-culture/export",
  "cultureOrigin/NON_EU": "origin-of-culture/no-eu",
  "cultureOrigin/UE": "origin-of-culture/eu",
  "cultureOrigin/XXX": "origin-of-culture/empty"
};
